const configuredBaseUrl = import.meta.env.VITE_FONT_CATALOG_BASE_URL || 'https://font-flow.pages.dev/'

/**
 * External font catalog root. Self-hosted builds can replace it with
 * VITE_FONT_CATALOG_BASE_URL without touching application code.
 */
const FONT_CATALOG_BASE_URL = configuredBaseUrl.replace(/\/+$/, '')
/** Every family without its file list; what the catalog screen loads. */
export const FONT_CATALOG_INDEX_URL = `${FONT_CATALOG_BASE_URL}/index.json`
/** The full catalog in one file. Read only from catalogs that predate index.json. */
export const FONT_CATALOG_MANIFEST_URL = `${FONT_CATALOG_BASE_URL}/manifest.json`

export function getFontCatalogFileUrl(path: string): string {
  return new URL(path, `${FONT_CATALOG_BASE_URL}/`).toString()
}

/** One family's full entry; the fingerprint makes each version its own URL. */
export function getFontCatalogFamilyUrl(id: string, detailHash?: string): string {
  const url = new URL(`families/${encodeURIComponent(id)}.json`, `${FONT_CATALOG_BASE_URL}/`)
  if (detailHash) url.searchParams.set('v', detailHash)
  return url.toString()
}
